import React, { useState } from "react";
import { Tooltip } from "@material-ui/core";
import LinkDialog from "./linkDialog";
import { LinkIcon } from "@icarius-icons/index";
import { getLocalizedString } from "@icarius-localization/strings";

const LinkInput = ({ data, handleChange }) => {

    const [linkDialogIsOpen, setLinkDialogIsOpen] = useState(false);

    return (
        <>
            <Tooltip title={getLocalizedString("enterLink")}>
                <LinkIcon
                    style={{ cursor: 'pointer' }}
                    onClick={() => setLinkDialogIsOpen(true)}
                />
            </Tooltip>
            {
                linkDialogIsOpen &&
                <LinkDialog
                    open={linkDialogIsOpen}
                    initialValue={data}
                    handleChange={(value) => handleChange(value)}
                    handleClose={() => setLinkDialogIsOpen(false)}
                />
            }
        </>
    )
}

export default LinkInput;